var render = function render(){var _vm=this,_c=_vm._self._c;return _c('grid-row',{class:_vm.actionButtonsClasses},_vm._l((_vm.notifications),function(notification,id){return (
              _vm.showNotification &&
              !notification.action.url.includes(
                'api/notifications/subscription/'
              )
            )?_c('grid-col',{key:'dashboard-notification' + id,attrs:{"lg":_vm.notifications.length === 1 ? 12 : 6}},[_c('button-primary',{domProps:{"innerHTML":_vm._s(notification.message)}})],1):_vm._e()}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }